/**
 * 技能类型定义
 *
 * 定义技能相关的TypeScript类型，供前端组件、服务和状态管理使用
 */

// ==================== 技能定义 ====================

/** 技能来源 */
export type SkillSource = 'filesystem' | 'database';

/** 技能信息（列表项） */
export interface Skill {
  id: number;
  user_id: number | null;
  name: string;
  description: string | null;
  is_system: boolean;
  source: SkillSource;
  created_at: string | null;
  updated_at: string | null;
}

/** 技能详情（包含内容） */
export interface SkillDetail extends Skill {
  content: string;
}

/** 创建技能请求 */
export interface SkillCreateRequest {
  name: string;
  content: string;
}

/** 更新技能请求 */
export interface SkillUpdateRequest {
  name?: string;
  content?: string;
}

/** 技能列表响应 */
export interface SkillsListResponse {
  skills: Skill[];
  total: number;
}

/** 技能详情响应 */
export interface SkillResponse extends SkillDetail {}

// ==================== 验证工具 ====================

/** 技能名称格式验证正则（hyphen-case） */
export const SKILL_NAME_PATTERN = /^[a-z][a-z0-9]*(-[a-z0-9]+)*$/;

/** 最大技能内容大小（1MB） */
export const MAX_SKILL_CONTENT_SIZE = 1 * 1024 * 1024;

/**
 * 验证技能名称格式
 */
export function isValidSkillName(name: string): boolean {
  return SKILL_NAME_PATTERN.test(name) && name.length <= 100;
}

/**
 * 验证技能内容大小
 */
export function isValidSkillContentSize(content: string): boolean {
  return new Blob([content]).size <= MAX_SKILL_CONTENT_SIZE;
}

/**
 * 验证 YAML frontmatter 格式
 */
export function hasYamlFrontmatter(content: string): boolean {
  return content.trim().startsWith('---');
}
